export {default as bisect, bisectRight, bisectLeft} from "./bisect";
export {default as ascending} from "./ascending";
export {default as bisector} from "./bisector";
export {default as cross} from "./cross";
export {default as descending} from "./descending";
export {default as deviation} from "./deviation";
export {default as extent} from "./extent";
export {default as histogram} from "./histogram";
export {default as thresholdFreedmanDiaconis} from "./threshold/freedmanDiaconis";
export {default as thresholdScott} from "./threshold/scott";
export {default as thresholdSturges} from "./threshold/sturges";
export {default as max} from "./max";
export {default as mean} from "./mean";
export {default as median} from "./median";
export {default as merge} from "./merge";
export {default as min} from "./min";
export {default as pairs} from "./pairs";
export {default as permute} from "./permute";
export {default as quantile} from "./quantile";
export {default as range} from "./range";
export {default as scan} from "./scan";
export {default as shuffle} from "./shuffle";
export {default as sum} from "./sum";
export {default as ticks, tickIncrement, tickStep} from "./ticks";
export {default as transpose} from "./transpose";
export {default as variance} from "./variance";
export {default as zip} from "./zip";



//////////////////
// WEBPACK FOOTER
// /home/circleci/pickle/~/d3-array/src/index.js
// module id = Rpnd
// module chunks = 0